export interface SidebarSubMenuItem {
  name: string;
  achorValue: string;
  notificationValue?: number;
}

export interface SidebarMenuItem {
  name: string;
  achorValue?: string;
  showMenu?: 0 | 1;
  subMenu?: SidebarSubMenuItem[];
  hasNotification?: boolean;
}

export function hasNavigableSidebarRoute(item: SidebarMenuItem): boolean {
  return Boolean(item.achorValue?.trim()) ||
    Boolean(item.subMenu?.some((subItem) => subItem.achorValue?.trim()));
}
